import type { InjectionKey } from 'vue'

/**
 * Builds the link that opens one uploaded document. The intake page provides
 * it bound to its link token; without it, UploadList shows plain filenames.
 */
export const documentHrefKey: InjectionKey<(id: number) => string> = Symbol('documentHref')
